<template>
  <div class="my flex">
    <div class="SideNavigation" style="flex: 1.2">
      <div class="unser">
        <img v-if="imgUrl==''" src="../../assets/imges/用户.png" alt="" />
        <img v-if="imgUrl!=''" :src="imgUrl" alt="" />
        <div v-if="userNmae==''"></div>
        <div v-if="userNmae!=''">{{userNmae}}</div>
      </div>
      <el-aside
        width="250px"
        collapse-transition="true"
        style="background-color: rgb(238, 241, 246)"
      >
        <el-menu unique-opened default-active="1-1">
          <el-submenu index="1">
            <template slot="title"
              ><i style="color: #177cb0" class="el-icon-message"></i
              >会员中心</template
            >
            <el-menu-item-group>
              <router-link to="/memberCenter" class="link">
                <el-menu-item index="1-1">会员中心</el-menu-item>
              </router-link>

              <router-link to="/myOrder" class="link">
                <el-menu-item index="1-2">我的订单</el-menu-item>
              </router-link>
              <router-link to="/coupons" class="link">
                <el-menu-item index="1-3">优惠券</el-menu-item>
              </router-link>
              <router-link to="/Invoice" class="link">
                <el-menu-item index="1-4">发票管理</el-menu-item>
              </router-link>
              <router-link to="/address" class="link">
                <el-menu-item index="1-5">收货地址管理</el-menu-item>
              </router-link>
              <router-link to="/PointsFor" class="link">
                <el-menu-item index="1-6">积分兑换</el-menu-item>
              </router-link>
              <router-link to="/myLower" class="link">
                <el-menu-item index="1-7">我的下级</el-menu-item>
              </router-link>
              <router-link to="/OnlineInvoicing" class="link">
                <el-menu-item index="1-8">在线计价</el-menu-item>
              </router-link>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"
              ><i style="color: #177cb0" class="el-icon-menu"></i>我的</template
            >
            <el-menu-item-group>
              <el-menu-item @click="instructions(1)" index="2-1">
                关于我们
              </el-menu-item>
              <el-menu-item @click="instructions(3)" index="2-2">
                用户协议
              </el-menu-item>
              <el-menu-item @click="instructions(2)" index="2-3">
                帮助中心
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

   
        </el-menu>
      </el-aside>
    </div>
    <div style="flex: 8">
      <router-view />
    </div>
    <el-dialog
      :title="title"
      center
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div style="height: 50vh; overflow-y: scroll" v-html="htmlList"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOrderApi } from "../../api/http/order";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      userNmae:'',
      imgUrl:null,//用户名称图片
      htmlList: "", //协议信息
    };
  },
created(){
  console.log(window.sessionStorage.getItem('Avatar'))
    if(window.sessionStorage.getItem('Avatar')!=''){
      this.imgUrl=window.sessionStorage.getItem('Avatar')
    }else{
      this.imgUrl==''
    }
    if(window.sessionStorage.getItem('Name')!=''){
      this.userNmae=window.sessionStorage.getItem('Name')
    }else{
      this.userNmae=''
    }
},
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    instructions(e) {
      if (e == 1) {
        this.title = "关于我们";
      } else if (e == 2) {
        this.title = "帮助中心";
      } else if (e == 3) {
        this.title = "用户协议";
      }
      let params = {
        type: e,
        page: 1,
        size: 20,
      };
      getOrderApi.getInfoList(params).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.htmlList = res.data.data[0].Content;
          this.dialogVisible = true;
        }
      });
    },

    //   退出登录
    exit() {
      this.$router.push({ path: "/" });
      window.sessionStorage.clear();
    },
  },
};
</script>
<style lang="scss" scoped>
.unser {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #999;
  img {
    background-color: #eee;
    margin-right: 1rem;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
}
.my {
  .SideNavigation {
    width: 250px;
    border-right: 0.1rem solid #eee;
    height: 80vh;
  }
  .left {
    // width: 15rem;
    // background-color: cornflowerblue;
    // height: 800px;
    .el-menu {
      // background-image: url(../../assets/imges/43.jpg);
      background-repeat: no-repeat;
      background-size: cover;
      object-fit: cover;

      // i{
      //      color: #1b8359;
      // }

      .el-menu-item-group {
        // background-image: url(../../assets/imges/43.jpg);
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/my.vue